const KEEPALIVE_PING_TIMEOUT = 20000;
export default class KeepAlive {
    constructor(socket) {
        this.keepaliveTimeout = null;
        this.socket = socket;
        this.queue();
    }
    static isPong(event) {
        let data = {};
        try {
            data = JSON.parse(event.data);
        }
        catch (e) { }
        return data.pong === 'PONG';
    }
    static sendPing(socket) {
        socket.send(JSON.stringify({ ping: 'PING' }));
    }
    clear() {
        if (this.keepaliveTimeout != null) {
            clearTimeout(this.keepaliveTimeout);
            this.keepaliveTimeout = null;
        }
    }
    restart() {
        this.clear();
        this.queue();
    }
    queue() {
        this.keepaliveTimeout = setTimeout(this.fire.bind(this), KEEPALIVE_PING_TIMEOUT);
    }
    fire() {
        KeepAlive.sendPing(this.socket);
        this.queue();
    }
}
//# sourceMappingURL=KeepAlive.js.map